import React from "react";
import PrepingReportList from "./PrepingReportList";

const PrepingReport = () => {
  return (
    <div className="">
      <main className="content">
        <div className="container-fluid p-0">
          <h1>Preping Report</h1>
          <hr />
          <PrepingReportList />
        </div>
      </main>
    </div>
  );
};

export default PrepingReport;